export default {
      id: "Icon--userCircle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--userCircle",
      toString: function () {
        return this.url;
      }
    }